import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useAnalyzeDraftStore = create(
  persist(
    (set) => ({
      aiOutput: '',
      originalPrompt: '',
      domain: '',
      audience: '',
      sensitivity: '',

      setAiOutput: (value) => set({ aiOutput: value }),
      setOriginalPrompt: (value) => set({ originalPrompt: value }),
      setDomain: (value) => set({ domain: value }),
      setAudience: (value) => set({ audience: value }),
      setSensitivity: (value) => set({ sensitivity: value }),

      clearAnalyzeDraft: () =>
        set({
          aiOutput: '',
          originalPrompt: '',
          domain: '',
          audience: '',
          sensitivity: '',
        }),
    }),
    {
      name: 'msml-health-analyze-draft',
    }
  )
);

export default useAnalyzeDraftStore;
